var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPartition = function SvgPartition(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.7001 3.2002C3.19715 3.2002 3.6001 3.60314 3.6001 4.1002L3.6001 14.0002C3.6001 14.4973 3.19715 14.9002 2.7001 14.9002C2.20304 14.9002 1.8001 14.4973 1.8001 14.0002L1.8001 4.1002C1.8001 3.60314 2.20304 3.2002 2.7001 3.2002Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29995 3.2002C6.79701 3.2002 7.19995 3.60314 7.19995 4.1002L7.19995 14.0002C7.19995 14.4973 6.79701 14.9002 6.29995 14.9002C5.8029 14.9002 5.39995 14.4973 5.39995 14.0002L5.39995 4.1002C5.39995 3.60314 5.8029 3.2002 6.29995 3.2002Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0571 13.023H14.1429V6.82617L11.0571 5.5811V13.023ZM14.7555 7.07335C14.7552 7.07327 14.755 7.07318 14.7548 7.07309L14.7555 7.07335ZM9 4.13983V13.9616C9 14.48 9.46051 14.9002 10.0286 14.9002H15.1714C15.7395 14.9002 16.2 14.48 16.2 13.9616V6.21494C16.2 5.84338 15.9598 5.50679 15.5874 5.35653L10.4445 3.28142C9.76455 3.00705 9 3.46138 9 4.13983Z",
    fill: "black"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPartition);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/partition.a348f234b626b7fcc869de5dc9bd681c.svg";